<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">
          <div class="card-header">
            <div class="row">
              <div class="col-12">
                <div class="pull-left">
                  <h4 class="card-title float-left" v-if="action === 'edit'">
                    {{ $t('user.editUserInfo') }}</h4>
                  <h4 class="card-title float-left" v-else-if="action === 'view'">
                    {{ $t('user.viewUserInfo') }}</h4>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <span class="badge badge-success" v-if="user.visibleState==='ACTIVE'">{{ user.visibleState }}</span>
                  <span class="badge badge-secondary"
                        v-else-if="user.visibleState==='DEACTIVATED'">{{ user.visibleState }}</span>
                  <span class="badge badge-danger" v-else>{{ user.visibleState }}</span>
                </div>
                <div class="form-group">
                  <label>{{$t('user.field.pinflNumber')}} </label>
                  <pinfl-input
                      :pinfl.sync="user.pinflNumber"
                      :placeholder="'Жисмоний шаҳснинг шаҳсий идентификация рақами (ЖШШИР 14 рақам) '"
                      :disabled="true"
                  />
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.username') }}</label>
                  <input type="text" class="form-control" v-model="user.username" :disabled="true">
                  <div class="red" v-if="!$v.user.username.required">{{ $t("user.validation.username") }}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.lastName') }} </label>
                  <input type="text" class="form-control" v-model="user.lastname" :disabled="true">
                  <div class="red" v-if="!$v.user.lastname.required">{{ $t("user.validation.lastName") }}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.firstName') }} </label>
                  <input type="text" class="form-control" v-model="user.firstname" :disabled="true">
                  <div class="red" v-if="!$v.user.firstname.required">{{ $t("user.validation.firstName") }}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.midName') }} </label>
                  <input type="text" class="form-control" v-model="user.midname" :disabled="true">
                  <div class="red" v-if="!$v.user.midname.required">{{ $t("user.validation.midName") }}</div>
                </div>

<!--                <div class="form-group">-->
<!--                  <label>{{ $t('user.field.email') }} <span class="red">*</span></label>-->
<!--                  <input type="email" class="form-control" v-model="user.email">-->
<!--                  <div class="red" v-if="!$v.user.email.required">{{ $t("user.validation.email") }}</div>-->
<!--                </div>-->

                <div class="form-group">
                  <label>{{ $t('user.field.identificationNumber') }}</label>
                  <the-mask type="text" class="form-control"
                            v-model="user.identificationNumber"
                            mask="#########" placeholder="123456789"
                            masked="masked"
                            :disabled="action === 'view'"
                  >
                  </the-mask>
<!--                  <div class="red" v-if="!$v.user.identificationNumber.required">-->
<!--                    {{ $t("user.validation.identificationNumber") }}-->
<!--                  </div>-->
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.mobilePhone') }} <span class="red">*</span></label>
                  <the-mask type="text" class="form-control"
                            v-model="user.mobilePhone"
                            mask="+(998)## ###-##-##" placeholder="+998 (XX) XXX XXXX"
                            masked="masked"
                            :disabled="action === 'view'"
                            @input="mobilePhoneUnique"
                  >
                  </the-mask>
                  <div class="red" v-if="!$v.user.mobilePhone.required">{{ $t("user.validation.mobilePhone") }}</div>
                  <div class="red" v-if="uniqueMobilePhone">{{'Бунақа мобил телефонли ходим системада мавжуд!'}}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.province') }} <span class="red">*</span></label>
                  <v-select
                      label="name"
                      v-model="user.province"
                      :filterable="false"
                      :options="provinces"
                      @search="onProvinceSearch"
                      @search:focus="onProvinceFocus"
                      @change="onProvinceChange"
                      :disabled="action === 'view'"
                  >
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="!$v.user.province.required">{{ $t("user.validation.province") }}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.region') }} <span class="red">*</span></label>
                  <v-select
                      label="name"
                      v-model="user.region"
                      :filterable="false"
                      :options="regions"
                      @search="onRegionSearch"
                      @search:focus="onRegionFocus"
                      :disabled="action === 'view'"
                  >
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="!$v.user.region.required">{{ $t("user.validation.region") }}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.administrationType') }}</label>
                  <v-select
                      label="displayName"
                      v-model="administrationTypeDto"
                      :options="userAdministrationTypeList"
                      :disabled="action === 'view'"
                  >
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                </div>

                <div class="form-group" v-if="profile && profile.authorities && profile.authorities.some(e => e === 'ROLE_ADMIN')">
                  <label class="checkbox pl-4" style="scale: 1.2;">
                    <input type="checkbox" v-model="user.forceUpdatePassword">
                    <span class="checkbox-label"> Паролни янгилашни мажбурлаш</span>
                  </label>
                </div>
                <div class="form-group" v-if="profile && profile.authorities && profile.authorities.some(e => e === 'ROLE_ADMIN')">
                  <button :disabled="processing" class="all-btn delete-btn" type="button" @click="saveDefaultPassword(user)">
                    <i class="fa fa-refresh mr-1"></i>
                    Default парол
                  </button>
                </div>

              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <role-multi-check-box :title="'Ходим мансабини тангланг'"
                                   v-model="user.authorities"
                                   :options="roles" :action="'EDIT'"
                                   :disabled="action === 'view'"
                                   @change="onChangeAuthorities"
                  />
                  <div class="red" v-if="!$v.user.authorities.required">Ходимда биттагина рол бўлиши шарт!</div>
                </div>
                <div class="form-group" v-if="user.authorities.some(e => e === 'ROLE_USER')">
                  <label>{{ $t('user.field.theEmployeesServiceOrganization') }} <span class="red">*</span></label>
                  <v-select v-model="user.serviceClient" label="text"
                            :options="owners"
                            :filterable="false"
                            @search="onOwnerSearch"
                            @search:focus="onOwnerFocus"
                            :class="{invalid : $v.user.serviceClient.$error}">
                    <template slot="option" slot-scope="option" v-if="option">
                      <div v-html="option.text"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="user && user.serviceClient && user.serviceClient.text">
                      <div v-html="user.serviceClient.text"
                           @click="$eventBus.$emit('search:focus')"></div>
                    </template>
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="$v.user.serviceClient.$error">
                    {{ $t("user.validation.theEmployeesServiceOrganization") }}
                  </div>
                </div>
                <div class="form-group" v-if="user.authorities.some(e => e === 'ROLE_ADMIN')">
                  <label class="label">Менеджер мансабини тангланг</label>
                  <div v-for="item in managerTypeList" :key="item.id">
                    <label class="checkbox">
                      <input type="checkbox" :value="item.id" v-model="user.managerType">
                      <span class="checkbox-label"> {{ item.name }} </span> <br>
                    </label>
                  </div>
                </div>
                <div :class="{'form-group': true, 'bg-light' : user.authorities.some(e => e === 'ROLE_APPRAISER')}">
                  <appraiser-type v-model="user.employeeDto"
                                  v-if="user.authorities.some(e => e === 'ROLE_APPRAISER')"
                                  :action="'EDIT'"
                                  ref="appraiserTypeComponent"
                  />
                </div>
<!--                @change="onChangeAppraiserForEdit"-->

              </div>
            </div>
            <div class="col-12 col-md-12" >
              <div class="form-group" v-if="user.managerType.length>0">
                <div class="section-header">
                  <h4>Менеджерга вилоятлар бириктириш</h4>
                </div>
                <div class="table-responsive">
                  <button class="all-btn add-btn justify-content-end" id="show-btn" @click="showModal" v-if="hasPermission('V2_USER_RESPONSIBLE_PERSON_ADD')">
                    {{ $t('user.field.toAdd') }}
                  </button>
                  <div class="table-wrapper">
                    <table class="table table-hover">
                      <thead>
                      <tr>
                        <th width="5%">№</th>
                        <th width="5%">ID</th>
                        <th width="17%">{{ $t("user.field.userProvinces") }}</th>
                        <th width="10%" class="text-center">{{ $t("common.startDate") }}</th>
                        <th width="15%" class="text-center">{{ $t("common.endDate") }}</th>
                        <th width="13%" class="text-center">{{ $t("user.field.info") }}</th>
                        <th width="15%" class="text-center">{{ $t("user.field.status") }}</th>
                        <th width="20%" class="text-center">{{ $t("action.edit") }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(responsiblePerson, index) in user.responsiblePersons" :key="responsiblePerson.id">
                        <td>{{ index + 1 }}</td>
                        <td>{{ responsiblePerson.id }}</td>
                        <td class="text-center">
                          <span v-for="userProvince in responsiblePerson.userProvinces" :key="userProvince.id">
                            {{ userProvince.name }} <br/>
                          </span>
                        </td>
                        <td class="text-center">{{ responsiblePerson.startDate }}</td>
                        <td class="text-center">
                          <span v-if="!responsiblePerson.byCurrentDate">{{ responsiblePerson.endDate }}</span>
                          <span v-else>Хозиргача</span>
                        </td>
                        <td class="text-center">{{ responsiblePerson.info }}</td>
                        <td class="text-center">{{ responsiblePerson.visibleState }}</td>
                        <td class="td-actions text-center">
                          <button v-if="hasPermission('V2_USER_RESPONSIBLE_PERSON_EDIT')" class="all-btn edit-btn table-action" id="show-btn" @click="editResposiblePerson(responsiblePerson)">
                            <i class="fa fa-edit"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <b-modal ref="addEditModal" hide-footer title="" size="lg">
                <div slot="modal-header">
                  <b><span class="text">{{ $t('user.field.attachRegionsToTheManager') }}</span></b>
                </div>

                <div class="form-group">
                  <label>{{ $t('user.field.province') }} <span class="red">*</span></label>
                  <v-select
                      label="name"
                      v-model="responsiblePerson.userProvinces"
                      :filterable="false"
                      :options="provinces"
                      :multiple="true"
                      @search="onProvinceSearch"
                      @search:focus="onProvinceFocus"
                      @change="onProvinceChange"
                      :disabled="action === 'view'"
                  >
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="!$v.responsiblePerson.userProvinces.required">{{$t("user.validation.province")}}
                  </div>
                </div>


                <div class="form-group">
                  <label>{{ $t("common.startDate") }}<span class="red">*</span></label>
                  <custom-date-picker
                      class="form-control"
                      format="dd/MM/yyyy"
                      v-model="responsiblePerson.startDate"
                      :date="responsiblePerson.startDate"
                      :clear-button="true">
                  </custom-date-picker>
                  <div class="red" v-if="!$v.responsiblePerson.startDate.required">{{$t("common.startDate")}}</div>
                </div>
                <label class="checkbox">
                  <input type="checkbox" name="byCurrentDate"
                         v-model="responsiblePerson.byCurrentDate"/>
                  <i>Хозирги сана</i>
                </label>
                <div class="form-group" v-if="!responsiblePerson.byCurrentDate">
                  <label>{{ $t("common.endDate") }}<span class="red">*</span></label>
                  <custom-date-picker
                      class="form-control"
                      format="dd/MM/yyyy"
                      v-model="responsiblePerson.endDate"
                      :date="responsiblePerson.endDate"
                      :clear-button="true">
                  </custom-date-picker>
                  <div class="red" v-if="!$v.responsiblePerson.endDate.required">{{$t("common.endDate")}}</div>
                </div>
                <div class="form-group">
                  <label>{{ $t('user.field.info') }}<span class="red">*</span></label>
                  <textarea
                      cols="30" rows="3"
                      class="form-control"
                      v-model="responsiblePerson.info"
                  ></textarea>
                  <div class="red" v-if="!$v.responsiblePerson.info.required">{{ $t("user.validation.info") }}</div>

                </div>
                <div class="form-group">
                  <div class="form-check pl-0">
                    <label class="form-check-label" style="padding-left:22px !important">
                      <input class="form-check-input" type="checkbox"
                             v-model="responsiblePerson.visibleState">
                      <span class="form-check-sign"></span>
                      {{ $t("common.active") }}
                    </label>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12 btns-box">
                    <button class="all-btn delete-btn" @click="cancelExit" :disabled="processing">
                      {{ $t("action.cancel") }}
                    </button>
                    <button class="all-btn add-btn" @click="saveProvincesAttachedToTheManager" :disabled="processing"
                            v-if="action === 'edit'">
                      <i v-if="processing" class="fa fa-spinner fa-help"></i>{{ $t("action.save") }}
                    </button>

                  </div>
                </div>
              </b-modal>


              <div class="col-12 col-md-6">


              </div>
            </div>


          </div>
          <div class="row mt-5">
            <div class="col-12 btns-box">
              <button class="all-btn delete-btn " @click="cancel" :disabled="processing">
                <i class="fa fa-reply-all"></i>
                <span>{{ $t("action.cancel") }}</span>
              </button>
              <button  v-if="action==='edit' && hasPermission('V2_USER_DELETE')" class="all-btn delete-btn" @click="deleteUser(user)" :disabled="processing" >
                <i class="fa fa-trash-o"></i>
                <span>{{$t("action.delete")}}</span>
              </button>
              <button class="all-btn add-btn" @click="editUser" :disabled="processing" v-if="action === 'edit'">
                <i  class="fa fa-spinner fa-help" v-if="processing"></i>
                <i class="fa fa-floppy-o"></i>
                <span>{{$t("action.save")}}</span>
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initFilterModel from '@/shared/filter';
import DropZone from '@/views/dropZone/DropZone'
import PinflInput from "@/components/PinflInput.vue";
import {required, requiredUnless} from "vuelidate/lib/validators";
import bModal from "bootstrap-vue/es/components/modal/modal";
import {formatDate, parseDate} from '@/shared/utils';
import CustomDatePicker from '@/views/common/CustomDatePicker';
import Treeselect from "@riophae/vue-treeselect";
import AppraiserType from '@/components/AppraiserType'
import RoleMultiCheckbox from "@/components/user-type/role-multi-checkbox.vue";
import {mapState} from "vuex";
// import {pinflNumber} from "@/shared/pinfl-birthdate/pinfl-birthdate-validator";
export default {
  components: {
    Treeselect,
    CustomDatePicker,
    'b-modal': bModal,
    DropZone,
    PinflInput,
    "role-multi-check-box": RoleMultiCheckbox,
    "appraiser-type": AppraiserType,
  },
  data() {
    return {
      roles: [
        {id: "1", code: "ROLE_ADMIN", name: "Администратор"},
        {id: "2", code: "ROLE_GENERAL_DIRECTOR", name: "Генералний директор", disabled: true},
        {id: "3", code: "ROLE_DIRECTOR", name: "Директор"},
        {id: "8", code: "ROLE_REGIONAL_LEADER", name: "Худудий рахбар"},
        {id: "4", code: "ROLE_APPRAISER", name: "Баҳоловчи"},
        {id: "5", code: "ROLE_APPRAISER_HELPER", name: "Баҳоловчи ёрдамчиси"},
        {id: "6", code: "ROLE_USER", name: "Оддий фойдаланувчи"},
        {id: "7", code: "ROLE_FINANCIER", name: "Молиячи"}
      ],
      managerTypeList: [
        {id: "1", name: "Администратор"},
        {id: "2", name: "Support"}
      ],
      userAdministrationTypeList: [],
      processing: false,
      parseDate: parseDate,
      formatDate: formatDate,
      filter: initFilterModel(),
      filterProvince: initFilterModel(),
      filterRegion: initFilterModel(),
      action: 'edit',
      user: {
        pinflNumber:'',
        username: '',
        mobilePhone: '',
        administrationType: {},
        lastname: '',
        firstname: '',
        midname: '',
        // email: '',
        identificationNumber: null,
        province: {},
        region: 'yyyyy',
        authorities: [],
        description: null,
        active: false,
        serviceClient: {},
        managerType: [],

        buildings: [],
        responsiblePersons: [],
        evlGoalType: null,

        employeeDto: {
          appraiserType: '',
          evaluates: false,
          evlObjectTypes: [],
          employeeLicenseDto: {
          }
        },
        forceUpdatePassword: null,
        forceDefaultPassword: false

      },
      administrationTypeDto: {},
      responsiblePerson: {
        id: null,
        province: {},
        userProvincesNames: "",
        userProvinces: [],
        startDate: null,
        byCurrentDate: true,
        endDate: null,
        info: null,
        visibleState: true,
      },
      ownerFilter: initFilterModel(),
      espFileDto: {},
      provinces: [],
      regions: [],
      roleList: [],
      keyOwn: '',
      keyOwnR: '',
      color: '',
      items: [],
      type: '',
      owners: [
        {text: '', name: ''}

      ],
      uniqueMobilePhone: false,
    }
  },


  validations() {
    return {
      user: {
        username: {
          required: required
        },
        firstname: {
          required: required
        },
        lastname: {
          required: required
        },
        midname: {
          required: required
        },
        // identificationNumber: {
        //   required: required
        // },
        province: {
          required: required
        },
        region: {
          required: required
        },
        mobilePhone: {
          required: required,
        },
        // pinflNumber: {
          // required: false,
          // pinflNumber: pinflNumber(),
        // },
        // email: {
        //   required: required
        // },
        serviceClient: {
          required: requiredUnless(() => {
            return !this.user.authorities.some(e => e === 'ROLE_USER');
          })
        },
        authorities: {
          required: required
        }

      },
      responsiblePerson: {
        userProvinces: {
          required: required
        },
        startDate: {
          required: required
        },
        info: {
          required: required
        },
        endDate:{
          required: requiredUnless(() => {
            return this.responsiblePerson.byCurrentDate;
          })
        }
      }


    }
  },
  computed: {
    ...mapState(['profile']),
    hasCreate() {
      return this.$route.query.isCreate != null
    }
  },
  methods: {
    editUser() {
      console.log('this.user = ')
      console.log(this.user)
      if (this.user.authorities.some(e => e === 'ROLE_APPRAISER')) {
        let isValidAppraiserType = this.$refs["appraiserTypeComponent"].isValid();
        if (!isValidAppraiserType) {
          return;
        }
        this.user.employeeDto = this.$refs["appraiserTypeComponent"].sendData();
        this.user.appraiser = this.user.authorities.some(e => e === 'ROLE_APPRAISER');
      }

      this.$v.user.$touch();
      if (this.$v.user.$invalid) {
        return;
      }
      if (this.uniqueMobilePhone) {
        return;
      }
      let vm = this;
      this.user.administrationType = null;
      if(this.administrationTypeDto!=null && this.administrationTypeDto.code!=null) {
        this.user.administrationType = this.administrationTypeDto.code;
      }
      if (this.isEmptyObject(this.user.identificationNumber)) {
        this.user.identificationNumber = null;
      }

      this.$http.post('/user/save', this.user)
          .then(res => {
            this.processing = true;
            if (res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.common.saved'),
                type: 'success',
                html: res.data.message
              });
              this.$router.push('/user/list')
            } else if (res.data.status === 'FAIL') {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.common.errorOccurred'),
                type: 'error',
                html: res.data.message
              });
            } else {
              this.$swal({
                title: this.$t('messages.common.error'),
                text: this.$t('messages.common.errorOccurred'),
                type: 'error',
                html: res.data.message
              });
            }
          }
          ).catch(function (error) {
              console.log(error.response.data.message);
              vm.$swal({
                title: vm.$t('messages.common.error'),
                text: vm.$t('messages.common.errorOccurred'),
                type: 'error',
                html: error.response.data.httpStatus + ", " + error.response.data.message
              });
          });
    },

    init() {
      const vm = this;
      const id = this.$route.params.id;


      if (this.$route && this.$route.params && this.$route.params.action && this.$route.params.action.length > 0) {
        vm.action = this.$route.params.action;
      }

      if (id != null) {
        this.$http.get(`/user/${id}`)
            .then(res => {
              if (res && res.data && res.data.status !== 'SUCCESS') {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.common.error'),
                  type: 'error'
                });
              } else {
                console.log(res.data.data);
                this.user = res.data.data;

                setTimeout(() => {
                  if (this.user.administrationType) {
                    const item = this.userAdministrationTypeList.filter((option, /*index*/) => {
                      return option? option.code === this.user.administrationType: null;
                    })[0];

                    var index = this.userAdministrationTypeList.indexOf(item);
                    if (index !== -1) {
                      this.administrationTypeDto = item;
                    }
                  }
                }, 1000);

                this.initProvince();
                this.initUserAdministrationTypeList();
              }
            }, err => {
              console.log(err)
            })
      }
    },
    mobilePhoneUnique() {
      const uniqueRequest = {id: this.user.id, mobilePhone: this.user.mobilePhone};
      this.$http.post('/user/checkUniqueUser', uniqueRequest)
          .then(res => {
            const response = res.data.data;
            console.log("response = ")
            console.log(response)
            if (response) {
              this.uniqueMobilePhone = true;
            } else {
              this.uniqueMobilePhone = false;
            }
          }, err => {
            console.log(err);
          });
    },

    deleteUser: function (user) {
      this.processing = true;
      const vm = this;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('Сиз хақиқатдан хам бу фойдаланувчини ўчириб ташламоқчимисиз?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.get('/user/delete-user/' + user.hashUuid)
              .then((res) => {
                console.log(res.data);
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('Фойдаланувчини муваффақиятли ўчирилди'),
                    type: 'success'
                  });
                  this.$router.push('/user/list');
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('фойдаланувчини ўчиришда хатолик юз берди'),
                  type: 'error'
                });
                this.processing = false;
              }).catch(function (error) {
                  console.log(error.response.data.message);
                  vm.$swal({
                    title: vm.$t('messages.common.error'),
                    text: vm.$t('messages.common.errorOccurred'),
                    type: 'error',
                    html: error.response.data.httpStatus + ", " + error.response.data.message
                  });
          });
        } else {
          this.processing = false;
        }
      });
    },

    onChange() {
      this.$emit('input', this.checked);
    },
    cancel() {
      this.$router.push('/user/list')
    },
    initProvince() {
      const vm = this;
      const promises = [
        this.$http.get('province/init')
      ];
      Promise.all(promises).then(function (values) {
        const initData = values[0].data;
        vm.provinces = initData.provinces;
        vm.getProvinceGetRegions();
      });
    },
    initUserAdministrationTypeList() {
      const vm = this;
      const promises = [
        this.$http.get('/user/user-administration-type')
      ];
      Promise.all(promises).then(function (values) {
        const initData = values[0].data;
        vm.userAdministrationTypeList = initData.data;
      });
    },
    getProvinceGetRegions() {
      if (this.provinces && this.provinces.length > 0) {
        this.provinces.forEach((province) => {
          if (province.id === this.user.provinceId) {
            this.user.province = province;
            this.regions = province.regions;

            province.regions.forEach((region) => {
              if (region.id === this.user.regionId) {
                this.user.region = region;

              }
            });
          }
        });
      }

    },
    onProvinceChange() {
      // if (this.user.province.id && this.user.province.id > 0) {
      //   if (this.regions.length > 0) {
      //     this.user.region = {}
      //   }
      // }
    },
    onProvinceFocus() {
      this.provinces = [];
      this.filterProvince.search = '';
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            console.log(this.provinces);
          }, err => {
            console.log(err);
          });
    },
    onProvinceSearch(searchTxt, loading) {
      loading(true);
      this.filterProvince.search = searchTxt;
      this.provinces = [];
      this.$http.post('/province/list', this.filterProvince)
          .then(res => {
            this.provinces = res.data.data;
            console.log(this.provinces);
            loading(false);
            this.filterProvince.search = '';
          }, err => {
            console.log(err);
          });
    },
    onRegionSearch(searchTxt, loading) {
      loading(true);
      this.regions = [];
      this.filterRegion.provinceId = this.user.province.id;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onRegionFocus() {
      this.regions = [];
      this.filterRegion.provinceId = this.user.province!=null ? this.user.province.id:null;
      this.$http.post('/region/search', this.filterRegion)
          .then(res => {
            this.regions = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    getUserByRole() {
      this.$http.get('/user/role/list')
          .then(res => {
            this.roleList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.ownerFilter.clientType = 'Legal';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.ownerFilter.clientType = 'Legal';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    showModal() {
      this.responsiblePerson = {
        visibleState: true
      };

      this.$refs['addEditModal'].show()
    },
    cancelExit() {
      this.$refs['addEditModal'].hide();
    },
    saveProvincesAttachedToTheManager() {
      this.$v.responsiblePerson.$touch();
      if (this.$v.responsiblePerson.$invalid) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('messages.common.warning'),
          type: 'warning',
          html: "Iltimos barcha maydonlarni to'diring"
        });
        return;
      }

      const existingItem = this.user.responsiblePersons.filter((option, /*index*/) => {
        return option? option.id === this.responsiblePerson.id: null;
      })[0];
      var index = this.user.responsiblePersons.indexOf(existingItem);
      if (index !== -1) {
        this.user.responsiblePersons.splice(index, 1);
      }
      this.user.responsiblePersons.push(
          {
            "id": this.responsiblePerson.id,
            "startDate": this.responsiblePerson.startDate,
            "endDate": !this.responsiblePerson.byCurrentDate ? this.responsiblePerson.endDate : null,
            "visibleState": this.responsiblePerson.visibleState ? "ACTIVE" : "DEACTIVATED",
            "byCurrentDate": this.responsiblePerson.byCurrentDate,
            "info": this.responsiblePerson.info,
            "userProvinces": this.responsiblePerson.userProvinces,
            "userId": this.user.id
          }
      );
      this.cancelExit();
    },
    editResposiblePerson(responsiblePerson) {
      this.responsiblePerson = responsiblePerson;
      this.$refs['addEditModal'].show();
    },
    onChangeAppraiserForEdit(employeeDto) {
      // console.log("onChangeAppraiserView = ")
      // console.log(employeeDto)
      this.user.appraiser = this.user.authorities.some(e => e === 'ROLE_APPRAISER');
      this.user.employeeDto = employeeDto;
    },
    onChangeAuthorities(authorities, option, event) {
      console.log("onChangeAuthorities = ")
      console.log(authorities)
      console.log(option)
      console.log(event)
      this.user.appraiser = authorities.some(e => e === 'ROLE_APPRAISER');

      if (!authorities.some(e => e === 'ROLE_ADMIN')) {
        this.user.responsiblePersons = [];
        this.user.managerType=[];
      }

      //this.user.employeeDto = employeeDto;
    },
    saveDefaultPassword(user) {
      let vm = this;
      vm.processing = true;
      vm.user.forceDefaultPassword = true;

      this.$http.post('/user/save-default-password/'+ user.hashUuid)
          .then(res => {
                this.processing = true;
                if (res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    type: 'success',
                    html: `<div><div class="lead">${this.$t('messages.common.saved')}</div>${res.data.additionalData ? `<br><div class="text-monospace">${Object.keys(res.data.additionalData).map(key => `${key}: '${res.data.additionalData[key]}'`).join(', ')}</div>` : ''}</div>`
                  });
                  this.$router.push('/user/list')
                } else if (res.data.status === 'FAIL') {
                  this.$swal({
                    title: this.$t('messages.common.error'),
                    text: this.$t('messages.common.errorOccurred'),
                    type: 'error',
                    html: res.data.message
                  });
                } else {
                  this.$swal({
                    title: this.$t('messages.common.error'),
                    text: this.$t('messages.common.errorOccurred'),
                    type: 'error',
                    html: res.data.message
                  });
                }
              }
          ).catch(function (error) {
        console.log(error.response.data.message);
        vm.$swal({
          title: vm.$t('messages.common.error'),
          text: vm.$t('messages.common.errorOccurred'),
          type: 'error',
          html: error.response.data.httpStatus + ", " + error.response.data.message
        });
      });
    },

  },
  created() {
    this.filterProvince.page.size = 1000;
    this.filterRegion.page.size = 1000;
    this.init();
    this.getUserByRole();

  }

}
</script>
<style scoped>

</style>